export default __webpack_public_path__ + "static/media/animateLogoFast.997645a4.svg";